<template>
  <div style="padding: 5px;">
    <input type="checkbox" v-model="setFilter">
    <label style="font-weight: normal; text-transform: none;"> {{ (setFilter) ? 'Filter:' : 'Kein Filter gesetzt' }} </label>
    <div v-if="setFilter">
      <label style="font-weight: normal; text-transform: none;"> 
        {{ title }}: <br>
        <input type="checkbox" v-model="value">
        {{ (value) ? 'Ja' : 'Nein' }} 
      </label>
      <b-btn class="btn btn-sm btn-block" @click="search"> Anwenden </b-btn>
    </div>
  </div>
</template>

<script>
import filterMixins from './filter-mixins'

export default {
  name: 'bool-filter',
  mixins: [filterMixins],
  data () {
    return {
      setFilter: false,
      value: false
    }
  },
  methods: {
    search () {
      this.$set(this.query.freeTextFilters, this.field, this.value)
      this.query.offset = 0
      this.$set(this.query, 'nChanges', this.query.nChanges + 1)
    },
    setOptions () {
      var setFilter = this.query.freeTextFilters[this.field]
      this.setFilter = (setFilter)
      this.value = setFilter || false
    }
  },
  watch: {
    'query.freeTextFilters': {
      handler () {
        this.setFilter = (this.query.freeTextFilters[this.field])
      }
    },
    setFilter (f) {
      if (!f) {
        this.$set(this.query.freeTextFilters, this.field, undefined)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plugins/booleanFilter.vue